/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Col,
  Row,
  Button,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  Container,
} from 'reactstrap';
import {
  AvForm, AvField,
} from 'availity-reactstrap-validation';
import { useHistory, useLocation } from 'react-router-dom';
import Media from 'react-media';
import styles from './index.module.scss';
import { postUsers } from '../../services/users';
import { signin } from '../../store/auth';
import ModalComponent from '../../components/modal/ModalComponent';
import CpforCnpjValidation from '../../helper/validateCPForCNPJ';

const maskPhone = (value) => value
  .replace(/\D/g, '')
  .replace(/(\d{2})(\d)/, '($1) $2')
  .replace(/(\d{5})(\d)/, '$1-$2')
  .replace(/(-\d{4})(\d+?)$/, '$1');

function maskCPFeCNPJ(number) {
  number = number.replace(/\D/g, '');
  if (number.length > 11) {
    number = number.replace(/^(\d{2})(\d)/, '$1.$2');
    number = number.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    number = number.replace(/\.(\d{3})(\d)/, '.$1/$2');
    number = number.replace(/(\d{4})(\d)/, '$1-$2');
  } else {
    number = number.replace(/\D/g, '');
    number = number.replace(/(\d{3})(\d)/, '$1.$2');
    number = number.replace(/(\d{3})(\d)/, '$1.$2');
    number = number.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }
  return number;
}

const Signup = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [field, setField] = useState({});
  const [disabledButton, setDisabledButton] = useState(false);
  const ifNewUser = sessionStorage.getItem('@newlyCreated');
  const location = useLocation();
  const hasAuth = useSelector((state) => state.auth.hasAuth);
  const [modalPolicy, setModalPolicy] = useState(false);
  const [checkPolicyModal, setCheckPolicyModal] = useState(false);

  const largura = window.screen.width;

  function handleFormChange(e) {
    setField({
      ...field,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === 'termsAndPolicy') {
      setCheckPolicyModal(e.target.checked);
      setField({ ...field, termsAndPolicy: e.target.checked });
    }
    if (e.target.name === 'cell_phone') {
      setField({ ...field, cell_phone: maskPhone(e.target.value) });
    }
    if (e.target.name === 'cpf') {
      setField({ ...field, cpf: maskCPFeCNPJ(e.target.value) });
    }
  }

  async function handleValidSubmit() {
    const {
      name, lastname, confirmationPassword, termsAndPolicy, ...filteredForm
    } = field;

    const responseCPF = CpforCnpjValidation(filteredForm.cpf);

    if (!termsAndPolicy) {
      toast.error('Para criar sua conta é preciso concordar com as nossas Políticas, Termos e Condições');
      setDisabledButton(false);
      return;
    }

    if (!responseCPF) {
      toast.error('Insira um CPF/CNPJ válido.');
      setDisabledButton(false);
      return;
    }

    if (!filteredForm.sellerML) {
      toast.error('Informe se é vendendor do Mercado Livre.');
      setDisabledButton(false);
      return;
    }

    try {
      setDisabledButton(true);
      const response = await postUsers({ fullname: `${name}  ${lastname}`, ...filteredForm });
      if (response.user) {
        dispatch(signin({
          email: response.user.email,
          password: filteredForm.password,
          remember: false,
        }));
        sessionStorage.setItem('@newlyCreated', true);
      }

      if (response.user.sellerML) {
        setTimeout(
          () => {
            window.location = 'https://auth.mercadolivre.com.br/authorization?response_type=code&client_id=1501723720239053&redirect_uri=https://app.mercadoacelerado.com.br/access-token';
          },
          2000,
        );
      } else {
        setTimeout(() => {
          history.push({
            pathname: '/account-created',
            state: { msg: 'Conta criada com sucesso!' },
          });
        }, 500);
      }
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error(error.response.data.msg);
      }
      setDisabledButton(false);
    }
  }

  const handleClickModal = () => {
    setModalPolicy(false);
    setField({ ...field, termsAndPolicy: true });
    setCheckPolicyModal(true);
  };

  useEffect(() => {
    if (!hasAuth) return;

    if (hasAuth && !ifNewUser) {
      const { from } = location.state || { from: { pathname: '/sales' } };
      history.replace(from);
    }
  }, []);

  return (
    <>
      <Media query={{ minWidth: '500px' }}>
        {(matches) => (matches ? (
          <Container sm={6} className="signUp-card" style={{ maxWidth: '1000px' }}>
            <Card lg={4} className="p-4" style={{ backgroundColor: '#F5F7FA' }}>
              <CardBody>
                <h1
                  className="pb-4 mb-0"
                  style={{ borderBottom: '1px solid #BBC8D2' }}
                >
                  Cadastre-se
                </h1>

                <Row form>
                  <Col md={4} className="pr-3">
                    <h5 className="mt-4" style={{ color: '#395c81' }}>É novo por aqui?</h5>
                    <p style={{ color: '#395c81', textAlign: 'justify' }}>
                      Comece hoje mesmo gratuitamente e use os dados para tomadas de
                      decisões assertivas e mais vendas na sua operação online.
                    </p>
                  </Col>
                  <Col md={8} className="pl-3">
                    <AvForm className="mb-4 mt-4" id="signupForm" onValidSubmit={() => { handleValidSubmit(); }}>
                      <Row form>

                        <Col md={6}>

                          <AvField
                            className={styles.white}
                            tabindex="1"
                            name="name"
                            label="Nome*"
                            for="name"
                            id="name"
                            type="text"
                            onChange={handleFormChange}
                            value={field.name}
                            validate={{
                              required: { value: true, errorMessage: 'Preencha um Nome.' },
                              minLength: { value: 2, errorMessage: 'Preencha um nome válido.' },
                              maxLength: { value: 256, errorMessage: 'Seu nome deve ter entre 2 e 256 caracteres.' },
                            }}
                            placeholder="Coloque aqui seu Nome"
                          />
                          <AvField
                            className={styles.white}
                            tabindex="3"
                            name="cpf"
                            label="CPF ou CNPJ*"
                            for="cpf"
                            id="cpf"
                            type="text"
                            value={field.cpf}
                            onChange={handleFormChange}
                            validate={{
                              required: { value: true, errorMessage: 'Preencha um número.' },
                              maxLength: { value: 18 },
                              pattern: { value: '', errorMessage: 'Coloque aqui um CPF ou CNPJ válido.' },
                            }}
                            placeholder="Coloque aqui seu CPF ou CNPJ"
                          />
                        </Col>
                        <Col md={6}>

                          <AvField
                            className={styles.white}
                            tabindex="2"
                            name="lastname"
                            label="Sobrenome*"
                            for="lastname"
                            id="lastname"
                            type="text"
                            onChange={handleFormChange}
                            value={field.lastname}
                            validate={{
                              required: { value: true, errorMessage: 'Preencha um sobrenome.' },
                              minLength: { value: 2, errorMessage: 'Preencha seu sobrenome válido.' },
                              maxLength: { value: 256, errorMessage: 'Seu sobrenome deve ter entre 2 e 256 caracteres.' },
                            }}
                            placeholder="Coloque aqui seu Sobrenome"
                          />
                          <AvField
                            className={styles.white}
                            tabindex="4"
                            name="cell_phone"
                            label="Celular/WhatsApp para contato (com DDD)*"
                            for="cell_phone"
                            id="cell_phone"
                            type="text"
                            value={field.cell_phone}
                            onChange={handleFormChange}
                            validate={{
                              required: { value: true, errorMessage: 'Preencha um número.' },
                              maxLength: { value: 15 },
                              pattern: { value: '', errorMessage: 'Coloque aqui um número de celular válido.' },
                            }}
                            placeholder="Ex: (XX) 9XXXX-XXXX"
                          />

                        </Col>
                      </Row>

                      <AvField
                        className={styles.white}
                        tabindex="5"
                        name="company"
                        label="Nome da empresa"
                        for="company"
                        id="company"
                        type="text"
                        onChange={handleFormChange}
                        value={field.company}
                        validate={{
                          minLength: { value: 2, errorMessage: 'Preencha um nome válido' },
                          maxLength: { value: 256 },
                        }}
                        placeholder="Nome da sua empresa aqui."
                      />

                      <FormGroup check inline className="align-items-start mb-4">
                        <Col className="p-0" md={7}>
                          <Label for="sellerML" style={{ fontSize: '0.875rem' }}>
                            Já vende no Mercado Livre?*
                          </Label>
                          <Col className="p-0" md={8}>
                            <p
                              style={{
                                fontSize: '10px',
                                color: '#707070',
                                lineHeight: 1.4,
                              }}
                            >
                              Ao clicar em “Sim“, solicitaremos a autorização da sua
                              conta no Mercado Livre para melhores orientações e
                              análises.
                            </p>
                          </Col>
                        </Col>

                        <Col
                          className="d-flex justify-content-center align-items-center"
                          md={1}
                          required
                        >
                          <Input type="radio" name="sellerML" id="sellerMLYes" onChange={handleFormChange} value="true" />
                          <Label tabindex="6" htmlFor="sellerMLYes" style={{ color: '#23364A', marginBottom: 0, cursor: 'Pointer' }}>
                            Sim
                          </Label>
                          <FormGroup check inline />
                          <Input type="radio" name="sellerML" id="sellerMLNo" onChange={handleFormChange} value="false" />
                          <Label tabindex="7" for="sellerMLNo" style={{ color: '#23364A', marginBottom: 0, cursor: 'Pointer' }}>
                            Não
                          </Label>
                        </Col>

                      </FormGroup>
                      <AvField
                        className={styles.white}
                        tabindex="8"
                        name="email"
                        label="Email para login na plataforma*"
                        for="email"
                        id="email"
                        type="email"
                        onChange={handleFormChange}
                        value={field.email}
                        validate={{
                          required: { value: true, errorMessage: 'insira um endereço de email.' },
                          minLength: { value: 4, errorMessage: 'Insira um endereço de email válido.' },
                          maxLength: { value: 256 },
                        }}
                        placeholder="Coloque aqui seu email que vai acessar o sistema"
                      />
                      <AvField
                        className={styles.white}
                        tabindex="9"
                        name="password"
                        label="Senha*"
                        for="password"
                        id="password"
                        type="password"
                        onChange={handleFormChange}
                        value={field.password}
                        validate={{
                          required: { value: true, errorMessage: 'Preencha aqui sua senha.' },
                          minLength: { value: 6, errorMessage: 'Insira uma senha com no mínimo 6 caracteres.' },
                          maxLength: { value: 256 },
                        }}
                        placeholder="Coloque aqui sua senha com no mínimo 6 caracteres"
                      />
                      <AvField
                        className={styles.white}
                        tabindex="10"
                        name="confirmationPassword"
                        label="Confirmação da senha*"
                        for="confirmpassword"
                        id="confirmpassword"
                        type="password"
                        onChange={handleFormChange}
                        value={field.confirmationPassword}
                        required
                        errorMessage="Senha inválida"
                        validate={{ match: { value: 'password', errorMessage: 'As senhas devem ser idênticas!' } }}
                        placeholder="Confirme sua senha"
                      />
                      <div className={styles.containerRadioPolicy}>

                        <Input
                          type="checkbox"
                          name="termsAndPolicy"
                          checked={checkPolicyModal}
                          id="termsAndPolicy"
                          className={styles.radioPolicy}
                          onChange={handleFormChange}
                        />

                        <p
                          className={styles.textAcceptPolicy}
                        >
                          Ao criar uma conta você concorda com as nossas
                          {' '}
                          <button
                            type="button"
                            style={{
                              color: '#23364A',
                              background: 'none',
                              border: 'none',
                              padding: '0',
                            }}
                            onClick={() => setModalPolicy(true)}
                          >
                            <ins>
                              <strong>
                                Políticas, Termos e Condições

                              </strong>
                            </ins>
                          </button>
                        </p>
                      </div>
                      <div>
                        <Button disabled={disabledButton} color="primary" size="lg" type="submit" form="signupForm" block tabindex="11">Crie uma conta </Button>
                        <ToastContainer />
                      </div>
                    </AvForm>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
        ) : (
          <Container lg={6} className="signUp-card">
            <Card xl={4} style={{ backgroundColor: '#F5F7FA' }}>
              <CardBody>
                <h1
                  className="pb-4 mb-0"
                  style={{ borderBottom: '1px solid #BBC8D2' }}
                >
                  Cadastre-se
                </h1>

                <Row form>
                  <Col md={4} className="pr-3">
                    <p className="mt-4" style={{ color: '#395c81' }}>É novo por aqui?</p>
                    <p style={{ color: '#395c81', fontSize: 'min(2.8vw, 1.4125rem)' }}>
                      Comece hoje mesmo gratuitamente e use os dados para tomadas
                      de decisões assertivas e mais vendas na sua operação online
                    </p>
                  </Col>
                  <Col md={8} className="pl-1">
                    <AvForm className="mb-4 mt-4" id="signupForm" onValidSubmit={() => { handleValidSubmit(); }}>
                      <Row form>

                        <Col md={6}>

                          <AvField
                            className={styles.white}
                            tabindex="1"
                            name="name"
                            label="Nome*"
                            for="name"
                            id="name"
                            type="text"
                            onChange={handleFormChange}
                            value={field.name}
                            validate={{
                              required: { value: true, errorMessage: 'Preencha um Nome.' },
                              minLength: { value: 2, errorMessage: 'Preencha um nome válido.' },
                              maxLength: { value: 256, errorMessage: 'Seu nome deve ter entre 2 e 256 caracteres.' },
                            }}
                            placeholder="Coloque aqui seu Nome"
                          />
                          <AvField
                            className={styles.white}
                            tabindex="2"
                            name="lastname"
                            label="Sobrenome*"
                            for="lastname"
                            id="lastname"
                            type="text"
                            onChange={handleFormChange}
                            value={field.lastname}
                            validate={{
                              required: { value: true, errorMessage: 'Preencha um sobrenome.' },
                              minLength: { value: 2, errorMessage: 'Preencha seu sobrenome válido.' },
                              maxLength: { value: 256, errorMessage: 'Seu sobrenome deve ter entre 2 e 256 caracteres.' },
                            }}
                            placeholder="Coloque aqui seu Sobrenome"
                          />

                        </Col>
                        <Col md={6}>

                          <AvField
                            className={styles.white}
                            tabindex="3"
                            name="cpf"
                            label="CPF ou CNPJ*"
                            for="cpf"
                            id="cpf"
                            type="text"
                            value={field.cpf}
                            onChange={handleFormChange}
                            validate={{
                              required: { value: true, errorMessage: 'Preencha um número.' },
                              maxLength: { value: 18 },
                              pattern: { value: '', errorMessage: 'Coloque aqui um CPF ou CNPJ válido.' },
                            }}
                            placeholder="Coloque aqui seu CPF ou CNPJ"
                          />

                          <AvField
                            className={styles.white}
                            tabindex="4"
                            name="cell_phone"
                            label="Celular/WhatsApp para contato (com DDD)*"
                            for="cell_phone"
                            id="cell_phone"
                            type="text"
                            value={field.cell_phone}
                            onChange={handleFormChange}
                            validate={{
                              required: { value: true, errorMessage: 'Preencha um número.' },
                              maxLength: { value: 15 },
                              pattern: { value: '', errorMessage: 'Coloque aqui um número de celular válido.' },
                            }}
                            placeholder="Ex: (XX) 9XXXX-XXXX"
                          />

                        </Col>
                      </Row>

                      <AvField
                        className={styles.white}
                        tabindex="5"
                        name="company"
                        label="Nome da empresa"
                        for="company"
                        id="company"
                        type="text"
                        onChange={handleFormChange}
                        value={field.company}
                        validate={{
                          minLength: { value: 2, errorMessage: 'Preencha um nome válido' },
                          maxLength: { value: 256 },
                        }}
                        placeholder="Nome da sua empresa aqui."
                      />

                      <FormGroup check inline className="align-items-start mb-4">
                        <Col className="p-0" md={7}>
                          <Label for="sellerML" style={{ fontSize: '0.875rem' }}>
                            Já vende no Mercado Livre?*
                          </Label>
                          <Col className="p-0" md={8}>
                            <p
                              style={{
                                fontSize: '10px',
                                color: '#707070',
                                lineHeight: 1.4,
                              }}
                            >
                              Ao clicar em “Sim“, solicitaremos a autorização da sua
                              conta no Mercado Livre para melhores orientações e
                              análises.
                            </p>
                          </Col>
                        </Col>

                        <Col
                          style={{ flexDirection: 'column' }}
                          className="d-flex justify-content-center align-items-center"
                          md={1}
                          required
                        >
                          <Row>
                            <Input type="radio" name="sellerML" id="sellerMLYes" onChange={handleFormChange} value="true" />
                            <Label tabindex="6" htmlFor="sellerMLYes" style={{ color: '#23364A', marginBottom: 0, cursor: 'Pointer' }}>
                              Sim
                            </Label>
                          </Row>
                          {/* <FormGroup check inline /> */}
                          <Row style={{ marginTop: '0.5rem' }}>
                            <Input type="radio" name="sellerML" id="sellerMLNo" onChange={handleFormChange} value="false" style={{ marginLeft: '0.2rem' }} />
                            <Label tabindex="7" for="sellerMLNo" style={{ color: '#23364A', marginBottom: 0, cursor: 'Pointer' }}>
                              Não
                            </Label>
                          </Row>
                        </Col>

                      </FormGroup>
                      <AvField
                        className={styles.white}
                        tabindex="8"
                        name="email"
                        label="Email para login na plataforma*"
                        for="email"
                        id="email"
                        type="email"
                        onChange={handleFormChange}
                        value={field.email}
                        validate={{
                          required: { value: true, errorMessage: 'insira um endereço de email.' },
                          minLength: { value: 4, errorMessage: 'Insira um endereço de email válido.' },
                          maxLength: { value: 256 },
                        }}
                        placeholder="Coloque aqui seu email"
                      />
                      <AvField
                        className={styles.white}
                        tabindex="9"
                        name="password"
                        label="Senha*"
                        for="password"
                        id="password"
                        type="password"
                        onChange={handleFormChange}
                        value={field.password}
                        validate={{
                          required: { value: true, errorMessage: 'Preencha aqui sua senha.' },
                          minLength: { value: 6, errorMessage: 'Insira uma senha com no mínimo 6 caracteres.' },
                          maxLength: { value: 256 },
                        }}
                        placeholder="Coloque aqui sua senha"
                      />
                      <AvField
                        className={styles.white}
                        tabindex="10"
                        name="confirmationPassword"
                        label="Confirmação da senha*"
                        for="confirmpassword"
                        id="confirmpassword"
                        type="password"
                        onChange={handleFormChange}
                        value={field.confirmationPassword}
                        required
                        errorMessage="Senha inválida"
                        validate={{ match: { value: 'password', errorMessage: 'As senhas devem ser idênticas!' } }}
                        placeholder="Confirme sua senha"
                      />
                      <div className={styles.containerRadioPolicy}>

                        <Input
                          type="checkbox"
                          name="termsAndPolicy"
                          checked={checkPolicyModal}
                          id="termsAndPolicy"
                          className={styles.radioPolicy}
                          onChange={handleFormChange}
                        />

                        <p
                          className={styles.textAcceptPolicy}
                        >
                          Ao criar uma conta você concorda com as nossas
                          {' '}
                          <button
                            type="button"
                            style={{
                              color: '#23364A',
                              background: 'none',
                              border: 'none',
                              padding: '0',
                            }}
                            onClick={() => setModalPolicy(true)}
                          >
                            <ins>
                              <strong style={{ fontSize: '80%' }}>
                                Políticas, Termos e Condições

                              </strong>
                            </ins>
                          </button>
                        </p>
                      </div>
                      <div>
                        <Button disabled={disabledButton} color="primary" size="lg" type="submit" form="signupForm" block tabindex="11">Crie uma conta </Button>
                        <ToastContainer />
                      </div>
                    </AvForm>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
        ))}

      </Media>
      {modalPolicy && (
      <ModalComponent
        notShowHeader
        ModalActive={() => setModalPolicy(false)}
        width={largura < 500 ? '70%' : '50%'}
        height="70%"
        padding="0.8rem"
        heightContainer="100%"
        flexDirectionContainer="column"
      >
        <div className={styles.cardPolicy}>
          <Media query={{ minWidth: '500px' }}>
            {(matches) => (matches ? (
              <p style={{ textAlign: 'justify', margin: '1rem 2rem', fontFamily: 'Roboto' }}>
                <h2> Políticas, Termos e Condições do Mercado Acelerado</h2>
                <br />
                <p>
                  VISÃO GERAL
                </p>
                <br />

                Este site é operado pela Mercado Acelerado. Em todo o site, os termos "nós", "nós" e "nosso" se referem à Mercado Acelerado. Mercado Acelerado oferece este site, incluindo todas as informações, ferramentas e serviços disponíveis neste site, para você, o usuário, mediante a sua aceitação de todos os termos, condições, políticas e avisos estabelecidos aqui.
                <br />
                <br />
                Ao visitar nosso site e/ou contratar algum serviço em nosso site, você está utilizando nossos “Serviços” e, consequentemente, concorda com os seguintes termos e condições (“Termos de serviço”, “Termos”), incluindo os termos e condições e políticas adicionais mencionados neste documento e/ou disponíveis por hyperlink. Esses Termos de serviço se aplicam a todos os usuários do site, incluindo, entre outros, os usuários que são visualizadores, fabricantes, importadores, clientes, lojistas e/ou colaboradores de conteúdo.
                Leia estes Termos de serviço cuidadosamente antes de acessar ou utilizar o nosso site. Ao acessar ou usar qualquer parte do site, você concorda com os Termos de serviço. Se você não concorda com todos os termos e condições deste contrato, então você não pode acessar o site ou usar quaisquer serviços. Se esses Termos de serviço são considerados uma oferta, a aceitação é expressamente limitada a esses Termos de serviço.
                <br />
                <br />
                Quaisquer novos recursos ou ferramentas que forem adicionados à loja atual também devem estar sujeitos aos Termos de serviço. Você pode revisar a versão mais atual dos Termos de serviço quando quiser nesta página. Reservamo-nos o direito de atualizar, alterar ou trocar qualquer parte desses Termos de serviço ao publicar atualizações e/ou alterações no nosso site. É sua responsabilidade verificar periodicamente as alterações feitas nesta página. Seu uso contínuo ou acesso ao site após a publicação de quaisquer alterações constitui aceitação de tais alterações.
                <br />
                <br />
                SEÇÃO 1 - TERMOS DA PLATAFORMA VIRTUAL
                <br />
                <br />
                Ao concordar com estes Termos de serviço, você declara que tem idade mínima de maioridade em seu estado ou município de residência, ou que é maior de idade em seu estado ou município de residência, e que nos deu sua permissão para permitir que qualquer um de seus dependentes menores use este site.
                <br />
                <br />
                Você não deve usar nossos produtos para qualquer fim ilegal ou não autorizado. Você também não pode, ao usufruir deste Serviço, violar quaisquer leis em sua jurisdição (incluindo, entre outras, as leis de direitos autorais).
                <br />
                <br />
                Você não deve transmitir nenhum vírus ou qualquer código de natureza destrutiva.
                <br />
                <br />
                Violar qualquer um dos Termos resultará na rescisão imediata dos seus Serviços.
                <br />
                <br />
                SEÇÃO 2 - CONDIÇÕES GERAIS
                <br />
                <br />
                Reservamo-nos o direito de recusar o serviço a qualquer pessoa, por qualquer motivo, a qualquer momento.
                <br />
                <br />
                Você entende que o seu conteúdo (não incluindo informações de cartão de crédito) pode ser transferido sem criptografia e pode: (a) ser transmitido por várias redes; e (b) sofrer alterações para se adaptar e se adequar às exigências técnicas de conexão de redes ou dispositivos. As informações de cartão de crédito sempre são criptografadas durante a transferência entre redes.
                <br />
                <br />
                Você concorda em não reproduzir, duplicar, copiar, vender, revender ou explorar qualquer parte do Serviço, uso do Serviço, acesso ao Serviço, ou qualquer contato no site através do qual o Serviço seja fornecido, sem nossa permissão expressa por escrito.
                <br />
                <br />
                Os títulos usados neste contrato são incluídos apenas por conveniência e não limitam ou afetam os Termos.
                <br />
                <br />
                SEÇÃO 3 - PRECISÃO, COMPLETUDE E PERÍODO DE VALIDADE DAS INFORMAÇÕES
                <br />
                <br />
                Não nos responsabilizamos se as informações disponibilizadas neste site não forem precisas, completas ou atuais. O material deste site é fornecido apenas para fins informativos e não deve ser usado como a única base para tomar decisões sem consultar fontes de informações primárias, mais precisas, mais completas ou mais atuais. Qualquer utilização do material deste site é por sua conta e risco.
                <br />
                <br />
                Este site pode conter certas informações históricas. As informações históricas podem não ser atuais e são fornecidas apenas para sua referência. Reservamo-nos o direito de modificar o conteúdo deste site a qualquer momento, mas nós não temos obrigação de atualizar nenhuma informação em nosso site. Você concorda que é de sua responsabilidade acompanhar as alterações no nosso site.
                <br />
                <br />
                SEÇÃO 4 - ALTERAÇÕES DO SERVIÇO E DOS PREÇOS
                <br />
                <br />
                Os preços de nossos serviços estão sujeitos a alterações sem aviso prévio.
                <br />
                <br />
                Reservamo-nos o direito de, a qualquer momento, modificar ou descontinuar o Serviço (ou qualquer parte ou conteúdo do mesmo) sem aviso prévio em qualquer momento.
                <br />
                <br />
                Não nos responsabilizamos por você ou por qualquer terceiro por qualquer modificação, alteração de preço, suspensão ou descontinuação do Serviço.
                <br />
                <br />
                SEÇÃO 5 - PRODUTOS E SERVIÇOS (se aplicável)
                <br />
                <br />
                Certos serviços podem estar disponíveis exclusivamente online através do site. Tais serviços podem ter quantidades limitadas e são sujeitos a apenas cancelamento, de acordo com nossa Política.
                <br />
                <br />
                Fizemos todo o esforço possível para exibir da forma mais precisa os dados de nossas soluções na plataforma. Reservamo-nos o direito de, mas não somos obrigados a, limitar as vendas de nossos produtos ou Serviços para qualquer pessoa, região geográfica ou jurisdição. Podemos exercer esse direito conforme cada caso individual. Reservamo-nos o direito de limitar as quantidades de quaisquer produtos ou serviços que oferecemos. Todas as descrições de produtos ou preços de produtos são sujeitos a alteração a qualquer momento sem aviso prévio, a nosso critério exclusivo. Reservamo-nos o direito de descontinuar qualquer produto a qualquer momento. Qualquer oferta de produtos ou serviços neste site é nula onde for proibido por lei.
                <br />
                <br />
                Não garantimos que a qualidade de quaisquer produtos, serviços, informações ou outros materiais comprados ou obtidos por você vão atender às suas expectativas, ou que quaisquer erros no Serviço serão corrigidos.
                <br />
                <br />
                SEÇÃO 6 - PRECISÃO DE COBRANÇA E INFORMAÇÕES DA CONTA
                <br />
                <br />
                Nós nos reservamos o direito de recusar qualquer pedido que você fizer conosco. Podemos, a nosso próprio critério, limitar ou cancelar o número de produtos comprados por pessoa, por domicílio ou por pedido. Tais restrições podem incluir pedidos feitos na mesma conta de cliente, no mesmo cartão de crédito, e/ou pedidos que usem a mesma fatura e/ou endereço de entrega. Caso façamos uma alteração ou cancelemos uma solicitação, podemos tentar notificá-lo entrando em contato com o endereço de e-mail e/ou o número de telefone/endereço de faturamento fornecido no momento em que o pedido foi feito. Reservamo-nos o direito de limitar ou proibir pedidos que, a nosso critério exclusivo.
                <br />
                <br />
                Você concorda em fornecer suas informações de conta completas para todas as compras feitas em nossa plataforma. Você concorda em atualizar prontamente sua conta e outras informações, incluindo seu e-mail, números de cartão de crédito e datas de validade, para que possamos completar suas transações e contatar você quando preciso.
                <br />
                <br />
                SEÇÃO 7 - FERRAMENTAS OPCIONAIS
                <br />
                <br />
                Podemos fornecer a você acesso a ferramentas de terceiros sobre as quais não monitoramos nem temos controle ou entrada.
                <br />
                <br />
                Você reconhece e concorda que nós fornecemos acesso a tais ferramentas no estado em que se encontram e conforme a disponibilidade, sem quaisquer garantias, declarações ou condições de qualquer tipo e sem qualquer endosso. Não nos responsabilizamos de forma alguma pelo seu uso de ferramentas opcionais de terceiros.
                <br />
                <br />
                O uso de ferramentas opcionais oferecidas por meio do site é inteiramente por sua conta e risco, e você deve se familiarizar e aprovar os termos das ferramentas que são fornecidas por fornecedor(es) terceiro(s).
                <br />
                <br />
                Também podemos, futuramente, oferecer novos serviços e/ou recursos por meio do site (incluindo o lançamento de novas ferramentas e recursos). Tais recursos e/ou serviços novos também devem estar sujeitos a esses Termos de serviço.
                <br />
                <br />
                SEÇÃO 8 - LINKS DE TERCEIROS
                <br />
                <br />
                Determinados conteúdos, produtos e serviços disponíveis através do nosso Serviço podem incluir materiais de terceiros.
                <br />
                <br />
                Os links de terceiros nesse site podem direcionar você a sites de terceiros que não são Afiliados a nós. Não nos responsabilizamos por examinar ou avaliar o conteúdo ou sua precisão. Não garantimos e nem temos obrigação ou responsabilidade por quaisquer materiais ou sites de terceiros, ou por quaisquer outros materiais, produtos ou serviços de terceiros.
                <br />
                <br />
                Não somos responsáveis por quaisquer danos ou prejuízos relacionados com a compra ou uso de mercadorias, serviços, recursos, conteúdo, ou quaisquer outras transações feitas em conexão com quaisquer sites de terceiros. Por favor, leia com cuidado as políticas e práticas de terceiros e certifique-se de que você as entende antes de efetuar qualquer transação. As queixas, reclamações, preocupações ou questões relativas a produtos de terceiros devem ser direcionadas à respectiva empresa terceira.
                <br />
                <br />
                SEÇÃO 9 - COMENTÁRIOS, FEEDBACK E OUTRAS INTERAÇÕES DO USUÁRIO
                <br />
                <br />
                Se, a nosso pedido, você executar determinadas ações específicas (por exemplo, inscrições em concursos) ou, sem solicitação de nossa parte, enviar ideias criativas, sugestões, propostas, planos ou outros materiais, seja online, por e-mail, correio ou de outra forma (em conjunto designados "comentários"), você concorda que podemos, a qualquer momento, sem restrições, editar, copiar, publicar, distribuir, traduzir e usar, em qualquer meio, quaisquer comentários que você encaminhar para nós. Não nos responsabilizamos por: (1) manter quaisquer comentários em sigilo; (2) indenizar por quaisquer comentários; ou (3) responder quaisquer comentários.
                Podemos, mas não temos a obrigação, de monitorar, editar ou remover conteúdo que nós determinamos a nosso próprio critério ser contra a lei, ofensivo, ameaçador, calunioso, difamatório, pornográfico, obsceno ou censurável, ou que viole a propriedade intelectual de terceiros ou estes Termos de serviço.
                Você concorda que seus comentários não violarão qualquer direito de terceiros, incluindo direitos autorais, marcas registradas, privacidade, personalidade ou outro direito pessoal ou de propriedade. Você concorda que os seus comentários não conterão material difamatório, ilegal, abusivo ou obsceno. Eles também não conterão nenhum vírus de computador ou outro malware que possa afetar a operação do Serviço ou qualquer site relacionado. Você não poderá usar endereço de e-mail falso, fingir ser alguém diferente de si mesmo ou, de outra forma, enganar a nós ou terceiros quanto à origem de quaisquer comentários. Você é o único responsável por quaisquer comentários que faz e pela veracidade deles. Nós não assumimos qualquer responsabilidade ou obrigação por quaisquer comentários publicados por você ou por terceiros.
                <br />
                <br />
                SEÇÃO 10 - INFORMAÇÕES PESSOAIS
                <br />
                <br />
                Sua apresentação de informações pessoais por meio da plataforma é regida pela nossa Política de privacidade.
                <br />
                <br />
                SEÇÃO 11 - ERROS, IMPRECISÕES E OMISSÕES
                <br />
                <br />
                Por vezes, pode haver informações em nosso site ou no Serviço que contenham erros tipográficos, imprecisões ou omissões que possam estar relacionadas a descrições de produtos, preços, promoções, ofertas, cobranças de frete de produtos, tempos de trânsito e disponibilidade. Reservamo-nos o direito de corrigir quaisquer erros, imprecisões ou omissões, e de alterar ou atualizar informações ou cancelar pedidos caso qualquer informação no Serviço ou em qualquer site relacionado seja imprecisa, a qualquer momento e sem aviso prévio (até mesmo depois de você ter enviado o seu pedido).
                <br />
                <br />
                Não assumimos nenhuma obrigação de atualizar, alterar ou explicar informações no Serviço ou em qualquer site relacionado, incluindo, entre outras, as informações sobre preços, exceto conforme exigido por lei. Nenhuma atualização específica ou data de atualização no Serviço ou em qualquer site relacionado deve ser utilizada para indicar que todas as informações do Serviço ou em qualquer site relacionado tenham sido modificadas ou atualizadas.
                <br />
                <br />
                SEÇÃO 12 - USOS PROIBIDOS
                <br />
                <br />
                Além de outras proibições estabelecidas nos Termos de serviço, você está proibido de usar o site ou seu conteúdo para: (a) qualquer finalidade ilícita; (b) solicitar a outros que realizem ou participem de atos ilegais; (c) violar quaisquer regulamentos, regras, leis ou leis locais, internacionais, federais, municipais ou estaduais; (d) infringir ou violar nossos direitos de propriedade intelectual ou os direitos de propriedade intelectual de terceiros; (e) assediar, abusar, insultar, prejudicar, difamar, caluniar, desacreditar, intimidar ou discriminar com base no gênero, orientação sexual, religião, etnia, raça, idade, nacionalidade ou deficiência; (f) apresentar informações falsas ou enganosas;
                (g) enviar ou transmitir vírus ou qualquer outro tipo de código malicioso, que será ou poderá ser usado de qualquer forma que afete a funcionalidade ou operação do Serviço ou de qualquer site relacionado, outros sites ou a internet; (h) coletar ou rastrear as informações pessoais de terceiros; (i) prática de spam, phishing, pharm, pretext ou scrape; (j) qualquer propósito obsceno ou imoral; ou para (k) interferir ou contornar os recursos de segurança do Serviço ou de qualquer site relacionado, outros sites ou a internet. Reservamo-nos o direito de rescindir o seu uso do Serviço ou de qualquer site relacionado por violar qualquer um dos usos proibidos.
                <br />
                <br />
                SEÇÃO 13 - ISENÇÃO DE GARANTIAS; LIMITAÇÃO DE RESPONSABILIDADE
                <br />
                <br />
                Nós não prometemos, representamos ou garantimos que seu uso de nosso serviço será ininterrupto, oportuno, seguro ou livre de erros.
                Não garantimos que os resultados que possam ser obtidos pelo uso do serviço serão precisos ou confiáveis.
                <br />
                <br />
                Você concorda que, de tempos em tempos, podemos remover o serviço por períodos indefinidos de tempo ou cancelá-lo a qualquer momento, sem enviar aviso prévio para você.
                Você concorda que o seu uso ou incapacidade de usar o serviço é por sua conta e risco. O serviço e todos os produtos e serviços entregues através do serviço são (exceto conforme declarado por nós) fornecidos sem garantia e conforme a disponibilidade para seu uso, sem qualquer declaração, garantias ou condições de qualquer tipo, expressas ou implícitas, incluindo todas as garantias implícitas ou condições de comercialização, quantidade, adequação a uma finalidade específica, durabilidade, título e não violação.
                Em nenhum caso, a Mercado Acelerado, nossos diretores, executivos, funcionários, Afiliados, agentes, contratados, estagiários, fornecedores, provedores de serviços ou licenciantes serão responsáveis por qualquer dano, perda, reivindicação ou qualquer dano direto, indireto, incidental, punitivo, especial ou consequencial de qualquer tipo, incluindo, entre outros, lucros perdidos, perda de receita, perda de economias, perda de dados, custos de substituição ou quaisquer danos semelhantes, seja com base em contrato, ato ilícito (incluindo negligência), responsabilidade estrita ou não, decorrentes do uso de qualquer um dos serviços ou quaisquer produtos adquiridos usando o serviço, ou para qualquer outra reivindicação relacionada de qualquer forma ao seu uso do serviço ou qualquer produto, incluindo, entre outros, quaisquer erros ou omissões em qualquer conteúdo, ou qualquer perda ou dano de qualquer tipo incorrido como resultado do uso do serviço ou de qualquer conteúdo (ou produto) publicado, transmitido ou de outra forma disponibilizado através do serviço, mesmo se avisado de sua possibilidade.
                Como alguns estados ou jurisdições não permitem a exclusão ou a limitação de responsabilidade por danos indiretos ou incidentais, em tais estados ou jurisdições, a nossa responsabilidade será limitada à extensão máxima permitida por lei.
                <br />
                <br />
                SEÇÃO 14 - INDENIZAÇÃO
                <br />
                <br />
                Você concorda em indenizar, defender e isentar Mercado Acelerado e nossa matriz, subsidiárias, afiliadas, parceiros, executivos, diretores, agentes, contratados, licenciantes, prestadores de serviços, subcontratados, fornecedores, estagiários e funcionários, de qualquer reivindicação ou demanda, incluindo honorários advocatícios razoáveis, feitos por terceiros, devido a ou decorrente de sua violação destes Termos de serviço ou dos documentos que incorporam por referência, ou sua violação de qualquer lei ou dos direitos de terceiros.
                <br />
                <br />
                SEÇÃO 15 - INDEPENDÊNCIA
                <br />
                <br />
                No caso de qualquer disposição destes Termos de serviço ser considerada ilegal, nula ou inexequível, tal disposição será, no entanto, executável na extensão máxima permitida pela lei aplicável, e a parte inexequível será considerada como cortada destes Termos de serviço, e tal determinação não afetará a validade e aplicabilidade de quaisquer outras disposições remanescentes.
                <br />
                <br />
                SEÇÃO 16 - RESCISÃO
                <br />
                <br />
                As obrigações e as responsabilidades das partes incorridas antes da data de rescisão sobreviverão à rescisão deste contrato para todos os fins.
                <br />
                <br />
                Estes Termos de serviço permanecem em vigor, a menos que sejam rescindidos por você ou por nós. Você pode rescindir estes Termos de serviço a qualquer momento, notificando-nos que já não deseja utilizar os nossos serviços, ou quando você deixar de usar o nosso site.
                Se em nosso critério exclusivo você não cumprir com qualquer termo ou disposição destes Termos de serviço, nós também podemos rescindir este contrato a qualquer momento sem aviso prévio e você ficará responsável por todas as quantias devidas até a data da rescisão; também podemos lhe negar acesso a nossos Serviços (ou qualquer parte deles).
                <br />
                <br />
                SEÇÃO 17 - ACORDO INTEGRAL
                <br />
                <br />
                A falha de nossa parte em exercer ou executar qualquer direito ou disposição destes Termos de Serviço não constituirá uma renúncia de tal direito ou disposição.
                <br />
                <br />
                Estes Termos de serviço e quaisquer políticas ou normas operacionais publicadas por nós neste site ou no que diz respeito ao serviço constituem a totalidade do acordo entre nós. Estes termos regem o seu uso do Serviço, substituindo quaisquer acordos anteriores ou contemporâneos, comunicações e propostas, sejam verbais ou escritos, entre você e nós (incluindo, entre outros, quaisquer versões anteriores dos Termos de serviço).
                Quaisquer ambiguidades na interpretação destes Termos de serviço não devem ser interpretadas contra a parte que os redigiu.
                <br />
                <br />
                SEÇÃO 18 - LEGISLAÇÃO APLICÁVEL
                <br />
                <br />
                Estes Termos de serviço e quaisquer contratos separados nos quais fornecemos a você os Serviços serão regidos e interpretados de acordo com as leis do Brasil.
                <br />
                <br />
                SEÇÃO 19 - MUDANÇAS NOS TERMOS DE SERVIÇO
                <br />
                <br />
                Você pode revisar a versão mais atual dos Termos de serviço a qualquer momento nesta página.
                <br />
                <br />
                Reservamo-nos o direito, a nosso critério, de atualizar, modificar ou substituir qualquer parte destes Termos de serviço ao publicar atualizações e alterações no nosso site. É sua responsabilidade verificar periodicamente se há alterações em nosso site. Seu uso contínuo ou acesso ao nosso site ou ao Serviço após a publicação de quaisquer alterações a estes Termos de serviço constitui aceitação dessas alterações.
                <br />
                <br />
                {' '}
                <br />
                SEÇÃO 20 - INFORMAÇÕES DE CONTATO
                <br />
                {' '}
                <br />
                Perguntas sobre os Termos de serviço devem ser enviadas para nós em suporte@mercadoacelerado.com.
              </p>
            ) : (
              <p style={{
                margin: '1rem 0.5rem', fontFamily: 'Roboto', fontSize: 'min(2.2vw, 1.4125rem)',
              }}
              >
                <h2 style={{ fontSize: 'min(2.9vw, 1.6125rem)' }}> Políticas, Termos e Condições do Mercado Acelerado</h2>
                <br />
                <p style={{ fontSize: 'min(2.4vw, 1.6125rem)' }}>
                  VISÃO GERAL
                </p>
                <br />

                Este site é operado pela Mercado Acelerado. Em todo o site, os termos "nós", "nós" e "nosso" se referem à Mercado Acelerado. Mercado Acelerado oferece este site, incluindo todas as informações, ferramentas e serviços disponíveis neste site, para você, o usuário, mediante a sua aceitação de todos os termos, condições, políticas e avisos estabelecidos aqui.
                <br />
                <br />
                Ao visitar nosso site e/ou contratar algum serviço em nosso site, você está utilizando nossos “Serviços” e, consequentemente, concorda com os seguintes termos e condições (“Termos de serviço”, “Termos”), incluindo os termos e condições e políticas adicionais mencionados neste documento e/ou disponíveis por hyperlink. Esses Termos de serviço se aplicam a todos os usuários do site, incluindo, entre outros, os usuários que são visualizadores, fabricantes, importadores, clientes, lojistas e/ou colaboradores de conteúdo.
                Leia estes Termos de serviço cuidadosamente antes de acessar ou utilizar o nosso site. Ao acessar ou usar qualquer parte do site, você concorda com os Termos de serviço. Se você não concorda com todos os termos e condições deste contrato, então você não pode acessar o site ou usar quaisquer serviços. Se esses Termos de serviço são considerados uma oferta, a aceitação é expressamente limitada a esses Termos de serviço.
                <br />
                <br />
                Quaisquer novos recursos ou ferramentas que forem adicionados à loja atual também devem estar sujeitos aos Termos de serviço. Você pode revisar a versão mais atual dos Termos de serviço quando quiser nesta página. Reservamo-nos o direito de atualizar, alterar ou trocar qualquer parte desses Termos de serviço ao publicar atualizações e/ou alterações no nosso site. É sua responsabilidade verificar periodicamente as alterações feitas nesta página. Seu uso contínuo ou acesso ao site após a publicação de quaisquer alterações constitui aceitação de tais alterações.
                <br />
                <br />
                SEÇÃO 1 - TERMOS DA PLATAFORMA VIRTUAL
                <br />
                <br />
                Ao concordar com estes Termos de serviço, você declara que tem idade mínima de maioridade em seu estado ou município de residência, ou que é maior de idade em seu estado ou município de residência, e que nos deu sua permissão para permitir que qualquer um de seus dependentes menores use este site.
                <br />
                <br />
                Você não deve usar nossos produtos para qualquer fim ilegal ou não autorizado. Você também não pode, ao usufruir deste Serviço, violar quaisquer leis em sua jurisdição (incluindo, entre outras, as leis de direitos autorais).
                <br />
                <br />
                Você não deve transmitir nenhum vírus ou qualquer código de natureza destrutiva.
                <br />
                <br />
                Violar qualquer um dos Termos resultará na rescisão imediata dos seus Serviços.
                <br />
                <br />
                SEÇÃO 2 - CONDIÇÕES GERAIS
                <br />
                <br />
                Reservamo-nos o direito de recusar o serviço a qualquer pessoa, por qualquer motivo, a qualquer momento.
                <br />
                <br />
                Você entende que o seu conteúdo (não incluindo informações de cartão de crédito) pode ser transferido sem criptografia e pode: (a) ser transmitido por várias redes; e (b) sofrer alterações para se adaptar e se adequar às exigências técnicas de conexão de redes ou dispositivos. As informações de cartão de crédito sempre são criptografadas durante a transferência entre redes.
                <br />
                <br />
                Você concorda em não reproduzir, duplicar, copiar, vender, revender ou explorar qualquer parte do Serviço, uso do Serviço, acesso ao Serviço, ou qualquer contato no site através do qual o Serviço seja fornecido, sem nossa permissão expressa por escrito.
                <br />
                <br />
                Os títulos usados neste contrato são incluídos apenas por conveniência e não limitam ou afetam os Termos.
                <br />
                <br />
                SEÇÃO 3 - PRECISÃO, COMPLETUDE E PERÍODO DE VALIDADE DAS INFORMAÇÕES
                <br />
                <br />
                Não nos responsabilizamos se as informações disponibilizadas neste site não forem precisas, completas ou atuais. O material deste site é fornecido apenas para fins informativos e não deve ser usado como a única base para tomar decisões sem consultar fontes de informações primárias, mais precisas, mais completas ou mais atuais. Qualquer utilização do material deste site é por sua conta e risco.
                <br />
                <br />
                Este site pode conter certas informações históricas. As informações históricas podem não ser atuais e são fornecidas apenas para sua referência. Reservamo-nos o direito de modificar o conteúdo deste site a qualquer momento, mas nós não temos obrigação de atualizar nenhuma informação em nosso site. Você concorda que é de sua responsabilidade acompanhar as alterações no nosso site.
                <br />
                <br />
                SEÇÃO 4 - ALTERAÇÕES DO SERVIÇO E DOS PREÇOS
                <br />
                <br />
                Os preços de nossos serviços estão sujeitos a alterações sem aviso prévio.
                <br />
                <br />
                Reservamo-nos o direito de, a qualquer momento, modificar ou descontinuar o Serviço (ou qualquer parte ou conteúdo do mesmo) sem aviso prévio em qualquer momento.
                <br />
                <br />
                Não nos responsabilizamos por você ou por qualquer terceiro por qualquer modificação, alteração de preço, suspensão ou descontinuação do Serviço.
                <br />
                <br />
                SEÇÃO 5 - PRODUTOS E SERVIÇOS (se aplicável)
                <br />
                <br />
                Certos serviços podem estar disponíveis exclusivamente online através do site. Tais serviços podem ter quantidades limitadas e são sujeitos a apenas cancelamento, de acordo com nossa Política.
                <br />
                <br />
                Fizemos todo o esforço possível para exibir da forma mais precisa os dados de nossas soluções na plataforma. Reservamo-nos o direito de, mas não somos obrigados a, limitar as vendas de nossos produtos ou Serviços para qualquer pessoa, região geográfica ou jurisdição. Podemos exercer esse direito conforme cada caso individual. Reservamo-nos o direito de limitar as quantidades de quaisquer produtos ou serviços que oferecemos. Todas as descrições de produtos ou preços de produtos são sujeitos a alteração a qualquer momento sem aviso prévio, a nosso critério exclusivo. Reservamo-nos o direito de descontinuar qualquer produto a qualquer momento. Qualquer oferta de produtos ou serviços neste site é nula onde for proibido por lei.
                <br />
                <br />
                Não garantimos que a qualidade de quaisquer produtos, serviços, informações ou outros materiais comprados ou obtidos por você vão atender às suas expectativas, ou que quaisquer erros no Serviço serão corrigidos.
                <br />
                <br />
                SEÇÃO 6 - PRECISÃO DE COBRANÇA E INFORMAÇÕES DA CONTA
                <br />
                <br />
                Nós nos reservamos o direito de recusar qualquer pedido que você fizer conosco. Podemos, a nosso próprio critério, limitar ou cancelar o número de produtos comprados por pessoa, por domicílio ou por pedido. Tais restrições podem incluir pedidos feitos na mesma conta de cliente, no mesmo cartão de crédito, e/ou pedidos que usem a mesma fatura e/ou endereço de entrega. Caso façamos uma alteração ou cancelemos uma solicitação, podemos tentar notificá-lo entrando em contato com o endereço de e-mail e/ou o número de telefone/endereço de faturamento fornecido no momento em que o pedido foi feito. Reservamo-nos o direito de limitar ou proibir pedidos que, a nosso critério exclusivo.
                <br />
                <br />
                Você concorda em fornecer suas informações de conta completas para todas as compras feitas em nossa plataforma. Você concorda em atualizar prontamente sua conta e outras informações, incluindo seu e-mail, números de cartão de crédito e datas de validade, para que possamos completar suas transações e contatar você quando preciso.
                <br />
                <br />
                SEÇÃO 7 - FERRAMENTAS OPCIONAIS
                <br />
                <br />
                Podemos fornecer a você acesso a ferramentas de terceiros sobre as quais não monitoramos nem temos controle ou entrada.
                <br />
                <br />
                Você reconhece e concorda que nós fornecemos acesso a tais ferramentas no estado em que se encontram e conforme a disponibilidade, sem quaisquer garantias, declarações ou condições de qualquer tipo e sem qualquer endosso. Não nos responsabilizamos de forma alguma pelo seu uso de ferramentas opcionais de terceiros.
                <br />
                <br />
                O uso de ferramentas opcionais oferecidas por meio do site é inteiramente por sua conta e risco, e você deve se familiarizar e aprovar os termos das ferramentas que são fornecidas por fornecedor(es) terceiro(s).
                <br />
                <br />
                Também podemos, futuramente, oferecer novos serviços e/ou recursos por meio do site (incluindo o lançamento de novas ferramentas e recursos). Tais recursos e/ou serviços novos também devem estar sujeitos a esses Termos de serviço.
                <br />
                <br />
                SEÇÃO 8 - LINKS DE TERCEIROS
                <br />
                <br />
                Determinados conteúdos, produtos e serviços disponíveis através do nosso Serviço podem incluir materiais de terceiros.
                <br />
                <br />
                Os links de terceiros nesse site podem direcionar você a sites de terceiros que não são Afiliados a nós. Não nos responsabilizamos por examinar ou avaliar o conteúdo ou sua precisão. Não garantimos e nem temos obrigação ou responsabilidade por quaisquer materiais ou sites de terceiros, ou por quaisquer outros materiais, produtos ou serviços de terceiros.
                <br />
                <br />
                Não somos responsáveis por quaisquer danos ou prejuízos relacionados com a compra ou uso de mercadorias, serviços, recursos, conteúdo, ou quaisquer outras transações feitas em conexão com quaisquer sites de terceiros. Por favor, leia com cuidado as políticas e práticas de terceiros e certifique-se de que você as entende antes de efetuar qualquer transação. As queixas, reclamações, preocupações ou questões relativas a produtos de terceiros devem ser direcionadas à respectiva empresa terceira.
                <br />
                <br />
                SEÇÃO 9 - COMENTÁRIOS, FEEDBACK E OUTRAS INTERAÇÕES DO USUÁRIO
                <br />
                <br />
                Se, a nosso pedido, você executar determinadas ações específicas (por exemplo, inscrições em concursos) ou, sem solicitação de nossa parte, enviar ideias criativas, sugestões, propostas, planos ou outros materiais, seja online, por e-mail, correio ou de outra forma (em conjunto designados "comentários"), você concorda que podemos, a qualquer momento, sem restrições, editar, copiar, publicar, distribuir, traduzir e usar, em qualquer meio, quaisquer comentários que você encaminhar para nós. Não nos responsabilizamos por: (1) manter quaisquer comentários em sigilo; (2) indenizar por quaisquer comentários; ou (3) responder quaisquer comentários.
                Podemos, mas não temos a obrigação, de monitorar, editar ou remover conteúdo que nós determinamos a nosso próprio critério ser contra a lei, ofensivo, ameaçador, calunioso, difamatório, pornográfico, obsceno ou censurável, ou que viole a propriedade intelectual de terceiros ou estes Termos de serviço.
                Você concorda que seus comentários não violarão qualquer direito de terceiros, incluindo direitos autorais, marcas registradas, privacidade, personalidade ou outro direito pessoal ou de propriedade. Você concorda que os seus comentários não conterão material difamatório, ilegal, abusivo ou obsceno. Eles também não conterão nenhum vírus de computador ou outro malware que possa afetar a operação do Serviço ou qualquer site relacionado. Você não poderá usar endereço de e-mail falso, fingir ser alguém diferente de si mesmo ou, de outra forma, enganar a nós ou terceiros quanto à origem de quaisquer comentários. Você é o único responsável por quaisquer comentários que faz e pela veracidade deles. Nós não assumimos qualquer responsabilidade ou obrigação por quaisquer comentários publicados por você ou por terceiros.
                <br />
                <br />
                SEÇÃO 10 - INFORMAÇÕES PESSOAIS
                <br />
                <br />
                Sua apresentação de informações pessoais por meio da plataforma é regida pela nossa Política de privacidade.
                <br />
                <br />
                SEÇÃO 11 - ERROS, IMPRECISÕES E OMISSÕES
                <br />
                <br />
                Por vezes, pode haver informações em nosso site ou no Serviço que contenham erros tipográficos, imprecisões ou omissões que possam estar relacionadas a descrições de produtos, preços, promoções, ofertas, cobranças de frete de produtos, tempos de trânsito e disponibilidade. Reservamo-nos o direito de corrigir quaisquer erros, imprecisões ou omissões, e de alterar ou atualizar informações ou cancelar pedidos caso qualquer informação no Serviço ou em qualquer site relacionado seja imprecisa, a qualquer momento e sem aviso prévio (até mesmo depois de você ter enviado o seu pedido).
                <br />
                <br />
                Não assumimos nenhuma obrigação de atualizar, alterar ou explicar informações no Serviço ou em qualquer site relacionado, incluindo, entre outras, as informações sobre preços, exceto conforme exigido por lei. Nenhuma atualização específica ou data de atualização no Serviço ou em qualquer site relacionado deve ser utilizada para indicar que todas as informações do Serviço ou em qualquer site relacionado tenham sido modificadas ou atualizadas.
                <br />
                <br />
                SEÇÃO 12 - USOS PROIBIDOS
                <br />
                <br />
                Além de outras proibições estabelecidas nos Termos de serviço, você está proibido de usar o site ou seu conteúdo para: (a) qualquer finalidade ilícita; (b) solicitar a outros que realizem ou participem de atos ilegais; (c) violar quaisquer regulamentos, regras, leis ou leis locais, internacionais, federais, municipais ou estaduais; (d) infringir ou violar nossos direitos de propriedade intelectual ou os direitos de propriedade intelectual de terceiros; (e) assediar, abusar, insultar, prejudicar, difamar, caluniar, desacreditar, intimidar ou discriminar com base no gênero, orientação sexual, religião, etnia, raça, idade, nacionalidade ou deficiência; (f) apresentar informações falsas ou enganosas;
                (g) enviar ou transmitir vírus ou qualquer outro tipo de código malicioso, que será ou poderá ser usado de qualquer forma que afete a funcionalidade ou operação do Serviço ou de qualquer site relacionado, outros sites ou a internet; (h) coletar ou rastrear as informações pessoais de terceiros; (i) prática de spam, phishing, pharm, pretext ou scrape; (j) qualquer propósito obsceno ou imoral; ou para (k) interferir ou contornar os recursos de segurança do Serviço ou de qualquer site relacionado, outros sites ou a internet. Reservamo-nos o direito de rescindir o seu uso do Serviço ou de qualquer site relacionado por violar qualquer um dos usos proibidos.
                <br />
                <br />
                SEÇÃO 13 - ISENÇÃO DE GARANTIAS; LIMITAÇÃO DE RESPONSABILIDADE
                <br />
                <br />
                Nós não prometemos, representamos ou garantimos que seu uso de nosso serviço será ininterrupto, oportuno, seguro ou livre de erros.
                Não garantimos que os resultados que possam ser obtidos pelo uso do serviço serão precisos ou confiáveis.
                <br />
                <br />
                Você concorda que, de tempos em tempos, podemos remover o serviço por períodos indefinidos de tempo ou cancelá-lo a qualquer momento, sem enviar aviso prévio para você.
                Você concorda que o seu uso ou incapacidade de usar o serviço é por sua conta e risco. O serviço e todos os produtos e serviços entregues através do serviço são (exceto conforme declarado por nós) fornecidos sem garantia e conforme a disponibilidade para seu uso, sem qualquer declaração, garantias ou condições de qualquer tipo, expressas ou implícitas, incluindo todas as garantias implícitas ou condições de comercialização, quantidade, adequação a uma finalidade específica, durabilidade, título e não violação.
                Em nenhum caso, a Mercado Acelerado, nossos diretores, executivos, funcionários, Afiliados, agentes, contratados, estagiários, fornecedores, provedores de serviços ou licenciantes serão responsáveis por qualquer dano, perda, reivindicação ou qualquer dano direto, indireto, incidental, punitivo, especial ou consequencial de qualquer tipo, incluindo, entre outros, lucros perdidos, perda de receita, perda de economias, perda de dados, custos de substituição ou quaisquer danos semelhantes, seja com base em contrato, ato ilícito (incluindo negligência), responsabilidade estrita ou não, decorrentes do uso de qualquer um dos serviços ou quaisquer produtos adquiridos usando o serviço, ou para qualquer outra reivindicação relacionada de qualquer forma ao seu uso do serviço ou qualquer produto, incluindo, entre outros, quaisquer erros ou omissões em qualquer conteúdo, ou qualquer perda ou dano de qualquer tipo incorrido como resultado do uso do serviço ou de qualquer conteúdo (ou produto) publicado, transmitido ou de outra forma disponibilizado através do serviço, mesmo se avisado de sua possibilidade.
                Como alguns estados ou jurisdições não permitem a exclusão ou a limitação de responsabilidade por danos indiretos ou incidentais, em tais estados ou jurisdições, a nossa responsabilidade será limitada à extensão máxima permitida por lei.
                <br />
                <br />
                SEÇÃO 14 - INDENIZAÇÃO
                <br />
                <br />
                Você concorda em indenizar, defender e isentar Mercado Acelerado e nossa matriz, subsidiárias, afiliadas, parceiros, executivos, diretores, agentes, contratados, licenciantes, prestadores de serviços, subcontratados, fornecedores, estagiários e funcionários, de qualquer reivindicação ou demanda, incluindo honorários advocatícios razoáveis, feitos por terceiros, devido a ou decorrente de sua violação destes Termos de serviço ou dos documentos que incorporam por referência, ou sua violação de qualquer lei ou dos direitos de terceiros.
                <br />
                <br />
                SEÇÃO 15 - INDEPENDÊNCIA
                <br />
                <br />
                No caso de qualquer disposição destes Termos de serviço ser considerada ilegal, nula ou inexequível, tal disposição será, no entanto, executável na extensão máxima permitida pela lei aplicável, e a parte inexequível será considerada como cortada destes Termos de serviço, e tal determinação não afetará a validade e aplicabilidade de quaisquer outras disposições remanescentes.
                <br />
                <br />
                SEÇÃO 16 - RESCISÃO
                <br />
                <br />
                As obrigações e as responsabilidades das partes incorridas antes da data de rescisão sobreviverão à rescisão deste contrato para todos os fins.
                <br />
                <br />
                Estes Termos de serviço permanecem em vigor, a menos que sejam rescindidos por você ou por nós. Você pode rescindir estes Termos de serviço a qualquer momento, notificando-nos que já não deseja utilizar os nossos serviços, ou quando você deixar de usar o nosso site.
                Se em nosso critério exclusivo você não cumprir com qualquer termo ou disposição destes Termos de serviço, nós também podemos rescindir este contrato a qualquer momento sem aviso prévio e você ficará responsável por todas as quantias devidas até a data da rescisão; também podemos lhe negar acesso a nossos Serviços (ou qualquer parte deles).
                <br />
                <br />
                SEÇÃO 17 - ACORDO INTEGRAL
                <br />
                <br />
                A falha de nossa parte em exercer ou executar qualquer direito ou disposição destes Termos de Serviço não constituirá uma renúncia de tal direito ou disposição.
                <br />
                <br />
                Estes Termos de serviço e quaisquer políticas ou normas operacionais publicadas por nós neste site ou no que diz respeito ao serviço constituem a totalidade do acordo entre nós. Estes termos regem o seu uso do Serviço, substituindo quaisquer acordos anteriores ou contemporâneos, comunicações e propostas, sejam verbais ou escritos, entre você e nós (incluindo, entre outros, quaisquer versões anteriores dos Termos de serviço).
                Quaisquer ambiguidades na interpretação destes Termos de serviço não devem ser interpretadas contra a parte que os redigiu.
                <br />
                <br />
                SEÇÃO 18 - LEGISLAÇÃO APLICÁVEL
                <br />
                <br />
                Estes Termos de serviço e quaisquer contratos separados nos quais fornecemos a você os Serviços serão regidos e interpretados de acordo com as leis do Brasil.
                <br />
                <br />
                SEÇÃO 19 - MUDANÇAS NOS TERMOS DE SERVIÇO
                <br />
                <br />
                Você pode revisar a versão mais atual dos Termos de serviço a qualquer momento nesta página.
                <br />
                <br />
                Reservamo-nos o direito, a nosso critério, de atualizar, modificar ou substituir qualquer parte destes Termos de serviço ao publicar atualizações e alterações no nosso site. É sua responsabilidade verificar periodicamente se há alterações em nosso site. Seu uso contínuo ou acesso ao nosso site ou ao Serviço após a publicação de quaisquer alterações a estes Termos de serviço constitui aceitação dessas alterações.
                <br />
                <br />
                {' '}
                <br />
                SEÇÃO 20 - INFORMAÇÕES DE CONTATO
                <br />
                {' '}
                <br />
                Perguntas sobre os Termos de serviço devem ser enviadas para nós em suporte@mercadoacelerado.com.
              </p>
            ))}

          </Media>
        </div>
        <div className={styles.containerBtn}>
          <Button
            color="primary"
            size="lg"
            className={styles.btnPolicy}
            type="submit"
            onClick={handleClickModal}
          >
            Entendi
          </Button>
        </div>
      </ModalComponent>
      )}
    </>
  );
};

export default Signup;
